// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__iU6P3","questions":"styles_questions__2oafW","footer":"styles_footer__qOWUO"};